document.documentElement.classList.remove('no-js');

const q = (s, c=document) => c.querySelector(s);
const qa = (s, c=document) => [...c.querySelectorAll(s)];

function setOpen(el, open){
  if(!el) return;
  el.classList.toggle('is-open', open);
  el.setAttribute('aria-hidden', open ? 'false' : 'true');
  document.documentElement.style.overflow = open ? 'hidden' : '';
}

document.addEventListener('click', (e) => {
  const openMenu = e.target.closest('[data-open-menu]');
  const closeMenu = e.target.closest('[data-close-menu]');
  const openSearch = e.target.closest('[data-open-search]');
  const closeSearch = e.target.closest('[data-close-search]');
  if(openMenu) setOpen(q('#MobileMenu'), true);
  if(closeMenu) setOpen(q('#MobileMenu'), false);
  if(openSearch) { setOpen(q('#SearchPanel'), true); setTimeout(()=>q('#SearchPanel input[type="search"]')?.focus(),100); }
  if(closeSearch) setOpen(q('#SearchPanel'), false);
});

document.addEventListener('keydown', (e) => {
  if(e.key === 'Escape') { setOpen(q('#MobileMenu'), false); setOpen(q('#SearchPanel'), false); }
});

const header = q('[data-site-header]');
if(header){
  const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
  updateHeader(); addEventListener('scroll', updateHeader, {passive:True});
}

if('IntersectionObserver' in window){
  const obs = new IntersectionObserver((entries)=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');obs.unobserve(entry.target)}}), {threshold:.08});
  qa('[data-reveal]').forEach(el=>obs.observe(el));
}else{ qa('[data-reveal]').forEach(el=>el.classList.add('is-visible')); }

qa('[data-qty]').forEach(wrap=>{
  const input=q('input',wrap);
  wrap.addEventListener('click',e=>{
    const btn=e.target.closest('button[data-delta]'); if(!btn||!input)return;
    input.value=Math.max(1,(parseInt(input.value||1,10)+parseInt(btn.dataset.delta,10)));
  });
});
